import { authHeader } from '@/helpers';

export const categoryService = {
  get,
  getById,
  add,
  update,
  remove,
  exportExcel,
};

async function get() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_APIURL}/category/get`, requestOptions)
    .then((response) => response.json())
    .then(responseJson => {
      return responseJson;
    });
}

async function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_APIURL}/category/getbyid?id=${id}`, requestOptions)
    .then((response) => response.json())
    .then(responseJson => {
      return responseJson;
    });
}

async function add(category) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(category)
  };

  return fetch(`${process.env.VUE_APP_APIURL}/category/post`, requestOptions)
}

async function update(category) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(category)
  };

  return fetch(`${process.env.VUE_APP_APIURL}/category/put`, requestOptions)
}

async function remove(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
  };

  return fetch(`${process.env.VUE_APP_APIURL}/category/delete?id=${id}`, requestOptions)
}

async function exportExcel() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.VUE_APP_APIURL}/category/export`, requestOptions)
}

// async function importExcel(base64) {
//   var dto = {
//     base64: base64
//   }

//   const requestOptions = {
//     method: 'POST',
//     headers: authHeader(),
//     body: JSON.stringify(dto)
//   };

//   return fetch(`${process.env.VUE_APP_APIURL}/category/import`, requestOptions)
// }